export default __webpack_public_path__ + "static/i_4-fde80a2d2ae41909c7b7077aee76a02c.png";